import { DIETS } from "@/lib/api";

export default function DietFilters({ value, onChange }) {
  const toggle = (k) => onChange(value.includes(k) ? value.filter((x) => x !== k) : [...value, k]);
  return (
    <div className="flex flex-wrap gap-2" data-testid="diet-filters">
      {DIETS.map((d) => {
        const on = value.includes(d.key);
        return (
          <button key={d.key} type="button" data-testid={`filter-diet-${d.key}`} onClick={() => toggle(d.key)} aria-pressed={on}
            className={`rounded-full border px-4 py-1.5 text-sm font-medium transition-colors ${on ? "border-[#2E6F40] bg-[#2E6F40] text-white" : "border-[#1C241E]/15 bg-white text-[#4F5D52] hover:border-[#2E6F40]/50"}`}>
            {d.label}
          </button>
        );
      })}
    </div>
  );
}
